import { render } from "./Today.vue?vue&type=template&id=40084eb0&scoped=true"
import script from "./Today.vue?vue&type=script&lang=js"
export * from "./Today.vue?vue&type=script&lang=js"

import "./Today.vue?vue&type=style&index=0&id=40084eb0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40084eb0"]])

export default __exports__